
import { ServiceData } from '@/types/serviceTypes';

export const hardscapeProjectsService: ServiceData = {
  title: 'Hardscape Projects',
  description: 'Transform your outdoor living space with custom hardscape elements that add both beauty and functionality.',
  longDescription: [
    'Our expert hardscape installation services will transform your outdoor living space with beautiful, functional elements that stand the test of time. From elegant patios to striking walkways, we create custom hardscape features that complement your home\'s architecture and landscape design.',
    'We use only premium materials and employ skilled craftsmen who pay attention to every detail. Proper base preparation, precise installation techniques, and finishing touches ensure your hardscape projects will remain beautiful and functional for years to come.',
    'Whether you\'re looking to create an outdoor entertainment area, improve property access, or add distinctive decorative elements, our hardscaping services will enhance both the aesthetics and value of your property.'
  ],
  image: '/lovable-uploads/c9bab5be-8111-40c6-ae6f-a50a0408b536.png',
  features: [
    'Paver patios and walkways',
    'Natural stone installations',
    'Retaining and garden walls',
    'Outdoor kitchens and fire pits',
    'Steps and stone staircases'
  ],
  benefits: [
    'Increased usable outdoor living space',
    'Enhanced property value',
    'Reduced landscape maintenance',
    'Improved drainage and erosion control',
    'Year-round outdoor enjoyment'
  ],
  process: [
    {
      title: 'Design Consultation',
      description: 'We discuss your vision, needs, and budget to create the perfect hardscape plan.'
    },
    {
      title: 'Material Selection',
      description: 'Choose from premium pavers, natural stone, and other materials based on style and function.'
    },
    {
      title: 'Professional Installation',
      description: 'Our skilled team ensures proper base preparation and precise installation.'
    },
    {
      title: 'Final Inspection',
      description: 'We review the completed project to ensure every detail meets our quality standards.'
    }
  ],
  relatedServices: [
    { id: 'custom-stonework', title: 'Custom Stonework' },
    { id: 'masonry', title: 'Masonry' },
    { id: 'landscape-design', title: 'Landscape Design' }
  ]
};
